<template>
  <div>
    <router-view></router-view>
    <Dialog @ok="clearError"
            :visible="hasError"
            :title="errorTitle"
            :message="errorMessage"
            :show-cancel="false">
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/partial/Dialog.vue";
import {listen} from "@/util/eventHandler.js";
import {version} from "../package.json";

export default {
  components: {Dialog},
  name: "App",
  data() {
    return {
      hasError: false,
      errorTitle: "",
      errorMessage: "",
      version
    };
  },
  created() {
    listen("error", this.showError);
  },
  methods: {
    showError(error) {
      this.hasError = true;
      this.errorTitle = error.title || "Fehler";
      this.errorMessage = error.message || "Ein unbekannter Fehler ist aufgetreten.";
    },

    clearError() {
      this.hasError = false;
      this.errorTitle = "";
      this.errorMessage = "";
    },
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Figtree:wght@400;700&display=swap');
$purple: #5B41E1;

body {
  font-family: 'Figtree', sans-serif;
}

@keyframes rotate-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
  }
}

* {
  animation-name: fade-in;
  animation-duration: 0.5s;
}

a {
  color: #5B41E1;
}

label {
  font-weight: bold;
}

h3 {
  font-weight: bold;
}

.mb-1 {margin-bottom: 1rem;}
.mb-2 {margin-bottom: 2rem;}
.mb-3 {margin-bottom: 3rem;}
.mb-4 {margin-bottom: 4rem;}

.spinner {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  margin: 0 0 -2px 1rem;
  border: solid 2px white;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation-name: rotate-spinner;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.hint {
  font-size: 10px;
  color: #8F9098;
}

footer {
  padding: 5rem 0;
  opacity: 0.5;
}

table.table{
  th, td {
    border: none;
  }
  thead {
    font-size: 16px;
  }
  tbody {
    font-size: 14px;

    tr {
      border-bottom: solid 1px #EFEFEF;
    }
  }
}

.btn {
  padding: 16px;
  border-radius: 8px;
  font-weight: bold;

  &.btn-primary {
    background-color: #494A50;
    border-color: #494A50;
  }
}
</style>
